<template>
    <div>
        <div class="text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
            <slot></slot>
        </div>
        <div class="bg-white flex items-center justify-between border-gray-200">
            <div class="flex-1 flex items-center justify-between">
                <div>
                    <div class="relative z-0 inline-flex flex-wrap">
                        <a v-for="(v, i) in values" @click="select(v)"
                           class="cursor-pointer mr-2 mb-2 relative inline-flex items-center px-4 py-2 whitespace-nowrap rounded-lg border-2 bg-white text-sm font-medium hover:bg-gray-50"
                           :class="{
                            'border-indigo-500': isActive(v),
                            'text-gray-700 border-gray-300':true,
                        }">
                            {{ text[i] }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <p class="mt-2 text-sm text-gray-500" v-if="hasHelperSlot">
            <slot name="helper"></slot>
        </p>
    </div>
</template>

<script>
export default {
    name: "SelectSmall",

    props: {
        value: {},
        values: {
            type: Array,
        },
        text: {
            type: Array,
        },
    },

    data: (vm) => ({
        local: vm.value,
    }),

    computed: {
        hasHelperSlot() {
            return !!this.$slots['helper'];
        },
    },

    methods: {
        isActive(value) {
            return value === this.local;
        },
        select(value) {
            this.local = value;

            this.$emit('input', value);
        }
    }
}
</script>

<style scoped>

</style>
